



import { application } from "../controllers/application"

import GlitterTextController from "../controllers/tools/glitter_text_controller"
application.register("glitter-text", GlitterTextController)
